var Backbone = require('backbone')
var Config = require('config')
var App = require('app')
var BaseModel = require('src/common/base-model')
var _ = require('lodash')
var BaseCollection = require('src/common/base-collection')

var Groups = function () {
  // scheduleEntity = new ScheduleEntity()

  // var SchedulesCollection = Backbone.Collection.extend({
  //   model: scheduleEntity.Model,
  //   url: function () {
  //     return this.device.url() + '/schedules' // this mean that the AuthorCollection must reference an Author
  //   }
  // })

  // Helper Model to support patching the devices associated with a griup
  // group/3247236472364/devices
  var GroupDeviceModel = Backbone.Model.extend({
    url: function () {
      return this.group.url() + '/devices'
    }
  })

  // init
  var Group = BaseModel.extend({
    initialize: function () {
      this.devices = new GroupDeviceModel()
      this.devices.group = this // setting the author to the collection
    },
    urlRoot: Config.api.host + '/groups',
    idAttribute: '_id',
    defaults: {
    },
    validation: {
    },
    updateDevices: function (data, options) {
      var defaultOptions = { patch: true}
      // ugly addition, but the update triggers a POST instead of patch
      // so i'm adding a fake id to trigger the system into sending a patch
      data['id'] = 'backboneId'

      var options = _.extend(defaultOptions, options)
      this.devices.save(data, options)
    },
    sendCommand: function (data) {
      var command = {}

      var command = {
        'key':data.command,
        'value':data.value,
        'time':0
      }

      // channel
      // this is an exception caused by dali-x
      if (data.hasOwnProperty('channel')) {
        command['channel'] = data.channel;
      }

      var commandData = {
        'devices': [this.get('_id')],
        'commands': [command]
      }


      Backbone.ajax({
        type: 'POST',
        url: Config.api.host + '/commands/',
        data: JSON.stringify(commandData),
        success: function (val) {
        },
        error: function (val) {
          App.dialog.alert('Something went wrong while controlling the device.')
        }
      })
    }
  })

  var GroupsCollection = BaseCollection.extend({
    url: Config.api.host + '/groups',
    model: Group
    // parse: function (data) {
    //   if (!data.data) return data
    //   return data.data
    // }
  })

  // //
  var API = {
    getEntities: function (options) {
      if (!options) var options = {}
      var fetchParams = { reset: true }
      if (options) { if (options.query) fetchParams.data = options.query }

      var entities = new GroupsCollection([], options)
      if (!options.preventFetch) entities.fetch(fetchParams)
      return entities
    },
    getEntity: function (id) {
      var entity = new Group({_id: id})
      entity.fetch()
      return entity
    },
    newEntity: function () {
      return new Group()
    }
  }

  App.globalChannel.reply({
    'group:entities': API.getEntities,
    'group:entity': API.getEntity
  })

  App.globalChannel.reply('group:entity:new', function () {
    return API.newEntity()
  })

//
}

module.exports = Groups



// WEBPACK FOOTER //
// ./js/entities/groups.js